import { createMutationHook } from '../../createMutationHook'

export default createMutationHook<{ requirementId: number }, { content: string, fileType: string }>({
  httpMethod: 'POST',
  getEndpoint: ({ requirementId }) => `app/requirements/download-requirement/${requirementId}`
})
